<script setup lang="ts">
// Диалог «Несохранённые изменения» — единственный на приложение, рендерится
// в App.vue. Открывается confirmLeave() из useUnsavedGuard: гард роутера и
// формы-модалки ждут решения юзера. Esc/оверлей = «остаться».
import { useI18n } from 'vue-i18n'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { leaveConfirmOpen, resolveLeaveConfirm } from '@/composables/useUnsavedGuard'

const { t } = useI18n()

function onOpenChange(open: boolean) {
  if (!open) resolveLeaveConfirm(false)
}

function onLeave() {
  resolveLeaveConfirm(true)
}

function onStay() {
  resolveLeaveConfirm(false)
}
</script>

<template>
  <Dialog :open="leaveConfirmOpen" @update:open="onOpenChange">
    <DialogContent class="sm:max-w-sm" :show-close-button="false" elevated>
      <DialogHeader>
        <DialogTitle>{{ t('common.unsaved_title') }}</DialogTitle>
        <DialogDescription>{{ t('common.unsaved_description') }}</DialogDescription>
      </DialogHeader>
      <DialogFooter class="gap-2">
        <Button variant="outline" @click="onLeave">
          {{ t('common.unsaved_leave') }}
        </Button>
        <Button @click="onStay">
          {{ t('common.unsaved_stay') }}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>
